import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Velocity } from '@components/Velocity';
import { PlayerInput } from '@components/PlayerInput';
import { Tag } from '@components/Tag';

export class InputSystem extends System {
  update(_deltaTime: number): void {
    const players = this.getEntitiesWithComponents(Position, Velocity, PlayerInput, Tag);

    for (const player of players) {
      const tag = player.getComponent(Tag)!;
      if (tag.value !== 'player') continue;

      const position = player.getComponent(Position)!;
      const velocity = player.getComponent(Velocity)!;
      const input = player.getComponent(PlayerInput)!;

      // Move towards target position with gradual turning
      if (input.targetPosition) {
        const dx = input.targetPosition.x - position.x;
        const dy = input.targetPosition.y - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance > 5) {
          // Calculate desired angle
          const targetAngle = Math.atan2(dy, dx);
          
          // Calculate angle difference
          let angleDiff = targetAngle - velocity.angle;
          
          // Normalize angle difference to [-PI, PI]
          while (angleDiff > Math.PI) angleDiff -= 2 * Math.PI;
          while (angleDiff < -Math.PI) angleDiff += 2 * Math.PI;
          
          // Apply turn rate limit
          const turnAmount = Math.max(-velocity.turnRate, Math.min(velocity.turnRate, angleDiff));
          velocity.angle += turnAmount;
          
          // Set speed based on how aligned we are with target
          const alignment = Math.abs(angleDiff) < Math.PI / 4 ? 1 : Math.max(0.3, 1 - Math.abs(angleDiff) / Math.PI);
          velocity.speed = velocity.maxSpeed * alignment;
        } else {
          velocity.speed = 0;
          input.targetPosition = null;
        }
      } else {
        // No waypoint - hold position rather than drifting off-screen
        velocity.speed = 0;
      }
    }
  }
}
